<template lang="pug">
  main
    NavBarInventario
    ModalDelete(v-show="modalStatusDel" :title="titleModalDel" :content="contentModalDel" @padre:eliminar="deleteMarca")
    ModalInfo(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:close="cerrarModal")
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            p.title Listado de Marcas
              | &nbsp
              i.fas.fa-desktop
              | &nbsp
              a.button.is-dark.is-rounded.is-medium(@click="backPage")
                i.fas.fa-times
            
        .columns.columnTop(v-show="hayDatos")
          .column.is-4.is-offset-2
            h5.title Marcas
            table#tbMarcas.table.is-striped
              thead
                tr
                  th #
                  th Nombre de la Marca
              tbody
                tr(v-for="(data, index) in marcas" :key="data.id")
                  td 
                    a.button.is-primary.is-small(@click="editarMarca(data, index)") {{ index + 1 }} 
                  td 
                    | {{ data.nombre }} &nbsp
                    a.button.is-danger.is-rounded.is-small(@click="eliminarMarca(data)")
                      span.icon.is-small
                        i.fas.fa-times
          .column.is-7
            a.button.is-primary.is-rounded.is-small(@click="nuevaMarca" v-show="!agregandoMarca")
              i.fas.fa-plus
              | &nbsp Agregar Marca
            newMarca(@closeMarca="cerrarComponenteMarca" v-show="agregandoMarca")
            editMarca(@closeFormEditMarca="cerrarEditarMarca" v-show="editandoMarca" :marca="marcaSelected")
        .columns
          .column.is-offset-4.is-4
        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos.
        .columns.column-blanco
</template>

<script>
import Loader from '../shared/Loader.vue'
import HeaderInventario from './layout/HeaderInventario.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import ModalDelete from '@/components/shared/ModalDelete.vue'
import ModalInfo from '@/components/shared/ModalInfo.vue'
import newMarca from '@/components/inventario_Componentes/NewMarca.vue'
import editMarca from '@/components/inventario_Componentes/EditMarca.vue'
// import ListSubmarcas from '@/components/inventario_Componentes/ListSubmarcas.vue'
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'Marcas',
  components: { Loader, NavBarInventario, HeaderInventario, newMarca, editMarca, ModalDelete, ModalInfo, vueCustomScrollbar },
  data () {
    return {
      isLoading: true,
      marcas: [],
      hayDatos: false,
      agregandoMarca: false,
      editandoMarca: false,
      modalStatusDel: false,
      contentModalDel: '',
      titleModalDel: '',
      marcaToDelete: {},
      modalStatus: false,
      contentModal: '',
      titleModal: '',
      marcaSelected: {},
      settings: {
        maxScrollbarLength: 60
      }
    }
  },
  methods: {
    obtenerMarcas () {
      InventarioServices.getMarcas()
        .then(res => {
          console.log(res.data)
          if (res.data.length > 0) {
              this.marcas = res.data
              this.isLoading = false
              this.hayDatos = true
          } else {
            this.isLoading = false
            this.hayDatos = false
          }
        })
    },
    nuevaMarca () {
      this.agregandoMarca = true
      this.editandoMarca = false
      this.mostrandoMarcaDetalle = false
    },
    editarMarca (marca, indice) {
      console.log(marca)
      console.log(indice)
      this.marcaSelected = marca
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
        this.editandoMarca = true
        this.agregandoMarca = false
      }, 100)
    },
    cerrarComponenteMarca () {
      this.agregandoMarca = false
      this.obtenerMarcas()
    },
    cerrarEditarMarca () {
      this.editandoMarca = false
      this.obtenerMarcas()
    },
    unSelectMarcas() {
      let cats = Array.from(document.querySelectorAll('.itemMarcas'))
      cats.forEach(element => {
        element.classList.remove('is-active')
      });
    },
    eliminarMarca(marca) {
      console.log(marca)
      if (marca) {
        this.marcaToDelete = marca
        this.titleModalDel = 'Eliminar.'
        this.contentModalDel = `¿Seguro desea eliminar la marca ${marca.nombre}?`
        this.modalStatusDel = true
      }
    },
    deleteMarca(result) {
      console.log(result)
      this.modalStatusDel = false
      if (result === 'delete') { 
        this.isLoading = true
        InventarioServices.deleteMarca(this.marcaToDelete.id)
          .then(data => {
            console.log(data)
            this.isLoading = true
            if (data.success){

              setTimeout(() => {
              this.isLoading = false
              // this.actualizarList = true              
              this.titleModal = 'Marca Eliminada.'
              this.contentModal = `La Marca ${this.marcaToDelete.nombre} se ha Eliminado con Éxito.`
              this.modalStatus = true
              this.isLoading = false
              this.obtenerMarcas()
              }, 100)
            } else {
              setTimeout(() => {
                this.titleModal = 'Error.'
                this.contentModal = data.respuesta
                this.modalStatus = true
                this.isLoading = false
              }, 100)
            }
          })
      }
    },
    cerrarModal () {
      this.modalStatus = false
    },
    scrollHanle(evt) {
      console.log(evt)
    },
    backPage() {
      this.$router.back()
    }
  }, 
  created () {
    this.obtenerMarcas()
    setTimeout(() => {
      this.isLoading = false
    }, 500)
  }
}
</script>

<style lang="css" scoped> 
  .columnTop {
    margin-bottom: 0;
  }

  .column-blanco {
    padding-bottom: 100px;
  }  
</style>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/Marcas.vue